import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  CircularProgress,
  Typography,
  Grid,
  Paper
} from "@mui/material";
import ApiService from "../../modules/APIService.interceptors";
import CloseIcon from '@mui/icons-material/Close';
import PaymentsService from "../../services/payment.service";

const VoucherModal = ({
  open,
  onClose,
  imageSrc,
  paymentId,
  status,
  updatePaymentStatus,
  method,
  orderID,
  paymentInfo,
  paymentInfomation,
  setPaymentInformation
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && method !== 'Transfer') {
      const handleSubmit = async () => {
        try {
          const response = method === 'MercadoPago'
            ? await PaymentsService.getExternalInfoMpPayment(paymentInfo)
            : await PaymentsService.getExternalInfoPayPalPayment(paymentInfo);
          setPaymentInformation(response);
          console.log("Respuesta recibida:", response);
        } catch (error) {
          console.error("Error al consultar el pago:", error);
        }
      };
      handleSubmit();
    }
  }, [open, method]);


  const handleAction = async (action) => {
    setLoading(true);
    try {
      const response =
        action === "approve"
          ? await ApiService.confirmPaymentToTransfer(paymentId)
          : await ApiService.cancelPaymentToTransfer(paymentId);

      if (response) {
        updatePaymentStatus(
          paymentId,
          action === "approve" ? "approved" : "rejected"
        );
      }
    } catch (error) {
      console.error("Error updating payment status", error);
    }
    setLoading(false);
    onClose();
  };


  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <Button onClick={onClose} disabled={loading} style={{ position: "absolute", right: 10, top: 10, color: "#1c1c1c" }}>
        <CloseIcon fontSize="large" />
      </Button>

      {method == 'Transfer' &&
        <DialogContent style={{ display: "flex", justifyContent: "center" }}>
          <img
            src={imageSrc}
            alt="Imagen"
            style={{ maxWidth: "70%", height: "50%" }}
          />
        </DialogContent>}

      {method !== 'Transfer' && (
        <DialogContentText style={{ padding: 20 }}>
          <>
            <Typography variant="h6" gutterBottom>
              🧾 Información del Pago
            </Typography>
            <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography><strong>ID:</strong> {paymentInfomation?.mpRes?.id}</Typography>
                  <Typography><strong>Estado:</strong> {paymentInfomation?.mpRes?.status}</Typography>
                  <Typography><strong>Detalle:</strong> {paymentInfomation?.mpRes?.status_detail || paymentInfomation?.mpRes?.purchase_units[0].soft_descriptor}</Typography>
                  <Typography><strong>Monto:</strong> ${paymentInfomation?.mpRes?.transaction_amount || paymentInfomation?.mpRes?.purchase_units[0].amount.value
                  }</Typography>
                  <Typography><strong>Moneda:</strong> {paymentInfomation?.mpRes?.currency_id || paymentInfomation?.mpRes?.purchase_units[0].amount.currency_code}</Typography>
                  <Typography><strong>Método de pago:</strong> {paymentInfomation?.mpRes?.payment_method_id}</Typography>
                  <Typography><strong>Email pagador:</strong> {paymentInfomation?.mpRes?.payer?.email || paymentInfomation?.mpRes?.payer?.email_address
                  }</Typography>
                  <Typography><strong>Fecha:</strong>{new Date(paymentInfomation?.mpRes?.create_time).toLocaleString() || new Date(paymentInfomation?.mpRes?.date_created).toLocaleString()}</Typography>
                  <Typography><strong>Pais:</strong> {paymentInfomation?.mpRes?.payer?.address?.country_code
                  }</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  {paymentInfomation?.mpRes?.additional_info?.items?.[0]?.picture_url && (
                    <img
                      src={paymentInfomation?.mpRes?.additional_info?.items[0].picture_url}
                      alt="Imagen del producto"
                      style={{ width: "100%", borderRadius: 8 }}
                    />
                  )}
                </Grid>
              </Grid>
            </Paper>

            <Typography variant="h6" gutterBottom>
              📦 Información guardada localmente
            </Typography>
            <Paper elevation={2} sx={{ p: 2 }}>
              <Typography><strong>Producto:</strong> {paymentInfomation?.storedPayment?.data?.payment?.orders?.orderProduct?.product?.name}</Typography>
              <Typography><strong>Descripción:</strong> {paymentInfomation?.storedPayment?.data?.payment?.orders?.orderProduct?.product?.description}</Typography>
              <Typography><strong>Precio:</strong> ${paymentInfomation?.storedPayment?.data?.payment?.orders?.orderProduct?.product?.price}</Typography>
              <Typography>
                Estado de pago:{' '}
                <strong>
                  {paymentInfomation?.storedPayment?.data?.payment?.status === 'approved'
                    ? 'Confirmado'
                    : paymentInfomation?.storedPayment?.data?.payment?.status === 'rejected'
                      ? 'Rechazado'
                      : paymentInfomation?.storedPayment?.data?.payment?.status === 'pending' ? 'Pendiente' : paymentInfomation?.storedPayment?.data?.payment?.status === 'canceled' ? 'Cancelado' : ''}
                </strong>
              </Typography>
              {/* <Typography><strong>Estado:</strong> {paymentInfomation?.storedPayment?.data?.payment?.status}</Typography> */}
              <Typography><strong>Fecha:</strong> {new Date(paymentInfomation?.storedPayment?.data?.payment?.createdAt).toLocaleString()}</Typography>

            </Paper>
          </>

        </DialogContentText>
      )}

      <DialogActions>
        {(status !== "approved") && (
          <Button
            onClick={() => handleAction("approve")}
            color="success"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : "Aceptar"}
          </Button>
        )}
        {(status !== "rejected") && (
          <Button
            onClick={() => handleAction("reject")}
            color="error"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : "Rechazar"}
          </Button>
        )}
      </DialogActions>
    </Dialog >
  );
};

export default VoucherModal;
